import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import CheckButton from '../../leevo_ui/CheckButton/CheckButton'
import { useHistory } from 'react-router-dom'

export default function StudentAttendanceCheckButton({
  klassDaysStudent: { id, attended },
  toggleAttendance,
  label = null
}) {
  const history = useHistory()
  const [updatingAttendance, setUpdatingAttendance] = useState(false)
  const [hasAttended, setHasAttended] = useState(attended)

  useEffect(() => {
    setHasAttended(attended)
  }, [attended])

  function handleToggleAttendance() {
    const originalState = hasAttended

    setUpdatingAttendance(true)
    setHasAttended(!originalState)

    return Promise.resolve(toggleAttendance(id))
      .then(() => setUpdatingAttendance(false))
      .catch(() => {
        setHasAttended(originalState)
        setUpdatingAttendance(false)
        const message = 'Oops! Something went wrong while recording attendance.'
        history.replace({
          state: { notification: { message, color: 'red' } }
        })
      })
  }

  return (
    <div className="inline-flex items-center min-h-11 mr-2 pr-2">
      <CheckButton
        ariaProps={{ 'aria-pressed': hasAttended, 'aria-label': 'attendance' }}
        disabled={updatingAttendance}
        size={6}
        onClick={handleToggleAttendance}
        checked={hasAttended}
        className="inline-block"
        data-cy="attendance-button"
        loading={updatingAttendance}
      />
      {label && (
        <button
          type="button"
          onClick={handleToggleAttendance}
          disabled={updatingAttendance}
          className="ml-2 min-h-11 font-medium text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 rounded disabled:opacity-60"
          aria-label={`Mark attendance for ${label}`}
        >
          {label}
        </button>
      )}
    </div>
  )
}

StudentAttendanceCheckButton.propTypes = {
  klassDaysStudent: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    attended: PropTypes.bool.isRequired
  }).isRequired,
  toggleAttendance: PropTypes.func.isRequired,
  label: PropTypes.string
}
